import * as React from 'react'
import type { UseCase } from 'cf-types'
import type { DefaultPlan } from '../lib/plans'
import {
  PaymentsDialogConfigProvider,
  usePaymentsDialogConfigContext,
} from './payments-dialog-config-context'
import {
  PaymentsDialogFormProvider,
  usePaymentsDialogFormContext,
} from './payments-dialog-form-context'
// oxlint-disable-next-line cf-web/no-barrel-file
export type { PaymentsData, Platform } from './payments-dialog-types'
// oxlint-disable-next-line cf-web/no-barrel-file
export type { DefaultPlan } from '../lib/plans'
// oxlint-disable-next-line cf-web/no-barrel-file
export type { Plan } from '../lib/plans'

export function PaymentsDialogProvider({
  children,
  useCase = 'purchase',
  promo,
  defaultPlan,
}: {
  children: React.ReactNode
  useCase?: UseCase
  promo?: string
  defaultPlan: DefaultPlan
}) {
  return (
    <PaymentsDialogConfigProvider useCase={useCase} promo={promo} defaultPlan={defaultPlan}>
      <PaymentsDialogProviderContent>{children}</PaymentsDialogProviderContent>
    </PaymentsDialogConfigProvider>
  )
}

function PaymentsDialogProviderContent({ children }: { children: React.ReactNode }) {
  const { initialPaymentsData, defaultSubscriptionType, isUserBillingDetailsPending } =
    usePaymentsDialogConfigContext()

  return (
    <PaymentsDialogFormProvider
      initialPaymentsData={initialPaymentsData}
      defaultSubscriptionType={defaultSubscriptionType}
      isUserBillingDetailsPending={isUserBillingDetailsPending}
    >
      {React.useMemo(() => children, [children])}
    </PaymentsDialogFormProvider>
  )
}

export function usePaymentsDialogContext() {
  const config = usePaymentsDialogConfigContext()
  const form = usePaymentsDialogFormContext()

  return {
    ...config,
    ...form,
  }
}
